import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, Card, Row, Col, DatePicker } from 'antd';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Link, useHistory } from "react-router-dom";
import { InterviewDto } from "@gtpl/shared-models/hrms";
import { InterviewService } from '@gtpl/shared-services/hrms';
import { PlantsDropDown} from '@gtpl/shared-models/masters';
import { UnitcodeService} from '@gtpl/shared-services/masters';
import { HrmsEmployeeRequest } from '@gtpl/shared-models/masters';
import { HrmsEmployeeDetailsDto, RolesDto } from '@gtpl/shared-models/masters';
import { HrmsEmpDetService, RolesService } from '@gtpl/shared-services/masters';
import { ProfileRequest } from '@gtpl/shared-models/hrms';
import {ProfilesService} from '@gtpl/shared-services/hrms'
import { ProfilesDto } from '@gtpl/shared-models/hrms';
import './interview-form.css';
import { Interviewtype, StEnum } from '@gtpl/shared-models/common-models';
import moment from 'moment';
import { request } from 'http';


const { TextArea } = Input;
const { Option } = Select;

export interface InterviewFormProps {
  data: InterviewDto;
  updateInterview: (data: InterviewDto) => void;
  isUpdate: boolean;
  closeForm: () => void;
}

export function InterviewForm(props: InterviewFormProps) {
  const [form] = Form.useForm();
  const history = useHistory();
  const [interview, setInterview] = useState<InterviewDto[]>([]);
  const [employeeData, setEmployeeData] = useState<HrmsEmployeeDetailsDto[]>([]);
  const [profilesData, setprofilesData] = useState<ProfilesDto[]>([]);
  const [plantData, setPlantData] = useState<PlantsDropDown[]>([]);
  const unitsService = new UnitcodeService();
  const interviewService = new InterviewService();
  const empService = new HrmsEmpDetService();
  const service=new ProfilesService();
  const hrmsEmpDetService = new HrmsEmpDetService();

  
  let createdUser = "";
  if (!props.isUpdate) {
    createdUser = localStorage.getItem("createdUser");
  }

  useEffect(()=> {
    if(profilesData){
      console.log(profilesData)
    }
  },[profilesData])
  

  useEffect(() => {
     getAllActiveEmployees();
    getAllInterview();
    getAllPlants();
    getAllProfiles();
   

  }, [])
  const onReset = () => {
    form.resetFields();
  }
  const onFocus=() =>{
    console.log('focus');
  }
  
  const onSearch=(val)=> {
    console.log('search:', val);
  }
  const onBlur=() =>{
    console.log('blur');
  }

  const getAllActiveEmployees = () => {
    empService.getAllActiveEmployees().then(res => {
      if (res.status) {
        setEmployeeData(res.data);
      } else {
        if (res.intlCode) {
          setEmployeeData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setEmployeeData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }
  const getAllPlants = () => {
    unitsService.getAllPlants().then((res) => {
      if (res.status) {
        setPlantData(res.data);
      } else {
        if (res.intlCode) {
          setPlantData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          setPlantData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        }
        setPlantData([]);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setPlantData([]);
    })
  }

  const getAllProfiles = () => {
    service.getAllProfiles().then((res) => {
      if (res.status) {
        console.log(res.data)
        setprofilesData(res.data);
        // form.setFieldsValue({referredBy:res.data})
      } else {
        if (res.intlCode) {
          setprofilesData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          setPlantData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        }
        setprofilesData([]);
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      setprofilesData([]);
    })
  }

  
 
  const create = (interviewtData: InterviewDto) => {
    interviewService.createinterview(interviewtData)
      .then((res) => {
        if (res.status) {
          AlertMessages.getSuccessMessage('Interview mode Created Successfully');
          history.push('/interview-view');
          onReset();
        } else {
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      })
      .catch((err) => {
        AlertMessages.getErrorMessage(err.message);
      });
  };

  
  // const getSelectedProfileData = (req) => {
  //   const profileId = form.getFieldValue('profileId')
  //   const request = new ProfileRequest(req);
  //   service.getAllActiveProfiles(request).then(res => {
  //     if (res.status) {
       
  //       form.setFieldsValue({
        


  //       });
  //     } else {
  //       if (res.intlCode) {
  //         AlertMessages.getErrorMessage(res.internalMessage);
  //       } else {
  //         AlertMessages.getErrorMessage(res.internalMessage);
  //       }
  //     }
  //   }).catch(err => {
  //     AlertMessages.getErrorMessage(err.message);
  //   })
  // }

  const getSelectedEmployeeData = (req) => {
    const request = new HrmsEmployeeRequest(req);
    hrmsEmpDetService.getActiveEmployeesById(request).then(res => {
      if (res.status) {
        form. setFieldsValue ({
         
          interviewerMobieNo: res.data?.mobileNumber,
          
        });
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const getSelectedProfileData = (val,row) => {
    console.log(row)
    let profileName = form.getFieldValue("candidateName");
    const profile = profilesData.find(item => item.candidateName == profileName )
   let profileId = profile.profileId

    console.log(profileId)
    console.log(profilesData);
    const refById = profilesData.find(item => item.profileId == profileId).referredBy
console.log(refById)
    const data = employeeData.find(rec => rec.employeeId == Number(refById)).employeeName
    console.log(data)
    form.setFieldsValue({referredBy:data})
    // const request = new ProfileRequest(req);
    // service.getAllActiveProfiles(request).then(res => {
    //   if (res.status) {
    //     form.setFieldsValue({
    //       referredBy:res.data?. referredBy
      
    //     });
    //   } else {
    //     if (res.intlCode) {
    //       AlertMessages.getErrorMessage(res.internalMessage);
    //     } else {
    //       AlertMessages.getErrorMessage(res.internalMessage);
    //     }
    //   }
    // }).catch(err => {
    //   AlertMessages.getErrorMessage(err.message);
    // })
  }

  const saveData = (values: InterviewDto) => {
    console.log("test");
    if (props.isUpdate) {
      console.log(values);
      props.updateInterview(values);
    } else {
      console.log(values);
      create(values);
    }
  };
  const getAllInterview = () => {
    interviewService.getAllInterview().then(res => {
      if (res.status) {
        setInterview([]);
      }
      else {
        if (res.intlCode) {
          setInterview([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }

    }).catch(err => {
      setInterview([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }
  if (props?.data && props.data.interviewDate) {
    let interviewDate: any = moment(props.data.interviewDate);
    props.data.interviewDate = interviewDate;
  }
  return (


    <Card title={<span style={{ color: 'white' }}>Interview</span>}
      style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} extra={props.isUpdate == true ? "" : <Link to='/interview-view' ><span style={{ color: 'white' }} ><Button className='panel_button' >View </Button> </span></Link>} >


      <Form form={form} 
            name="control-hooks"
             layout="vertical" 
             initialValues={props.data} onFinish={saveData}>

        <Form.Item name="interviewId" style={{ display: "none" }} >
          <Input hidden />
        </Form.Item>
        <Form.Item style={{ display: "none" }} name="createdUser" initialValue={createdUser}>
          <Input hidden />
        </Form.Item>
        <Row>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item
              name="interviewDate"
              label="Interview Date"
              rules={[
                {
                  required: true,
                  message: "It should not be blank"
                },
              ]}
            >
              <DatePicker
                style={{ width: '100%' }}
                format="YYYY-MM-DD"
                showToday={true}
              />

            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item
              name="interviewType"
              label="Interview Type "
              rules={[
                {
                  required: true,
                  message: "It should not be blank"
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Interview Type "
                onFocus={onFocus}
                onBlur={onBlur}
                onSearch={onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                {/* {
                  Object.entries(Interviewtype).map((value) => {
                    return <Option value={value[1]} >{value[1]} </Option>
                  })
                } */}
                <Option key={1} value={Interviewtype.HrInterview} >{Interviewtype.HrInterview}</Option>
              </Select>

            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item
              name="interviewer"
              label="Interviewer"
              rules={[
                {
                  required: true,
                  message: "It should not be blank"
                },
              ]}
            >
                <Select
                placeholder="Select Employee Name"
                onChange={getSelectedEmployeeData}
              >
                <Option key={0} value={null}> Select Employee Code</Option>
                {employeeData.map((employee) => {
                  return <Option key={employee.employeeId} value={employee.employeeId}>{employee.employeeName}</Option>
                })}
              </Select> 
           
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item
              name="interviewerMobieNo"
              label="Interviewer.Mob.No"
              rules={[
                { required: true, message: ' Valid Mobile No is required' , max:10},
                {
                  pattern: /^[^-\s\\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][Z0-9_\s-]*$/,
                  message: `Don't Allow letters and Spaces`
                }
              ]}
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item
              name="plant"
              label="Plant"
              rules={[
                {
                  required: true,
                  message: "It should not be blank"
                },
              ]}
            >
               <Select
                  showSearch
                  placeholder="Select Plant "
                  optionFilterProp="children"

                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  {/* <Option value={undefined}>please select Plant</Option>; */}
                  {plantData.map(dropData => {
                    return <Option key={dropData?.plantId}value={dropData?.plantName}>{dropData?.plantName}</Option>;
                  })}
                </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item
              name="jobDescription"
              label="Job Description"
              rules={[
                {
                  required: true,
                  message: "It should not be blank"
                },
              ]}
            >
              <Input />

            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item
              name="candidateName"
              label="Candidate Name"
              rules={[
                {
                  required: true,
                  message: "It should not be blank"
                },
              ]}
            >
               <Select
                placeholder="Select Employee Name"
                onChange={getSelectedProfileData}
              >
                <Option key={0} value={null}> Select Employee Code</Option>
                {profilesData.map((profiles) => {
                  return <Option key={profiles.profileId} value={profiles.candidateName}>{profiles.candidateName}</Option>
                })}
              </Select> 
         
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item
              name="referredBy"
              label="Referred By"
              rules={[
                {
                  required: true,
                  message: "It should not be blank"
                },
              ]}
            >
              <Input disabled/>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item
              name="status"
              label="Status"
              rules={[
                {
                  required: true,
                  message: "It should not be blank"
                },
              ]}
            >
              <Select>
                {
                  Object.entries(StEnum).map((value) => {
                    return <Option value={value[1]}>{value[1]}</Option>
                  })
                }

                {/* <Select.Option value="Open">Open</Select.Option>
                          <Select.Option value="Selected">Selected</Select.Option>
                          <Select.Option value=" Pending "> Pending</Select.Option>
                          <Select.Option value=" Rejected"> Rejected</Select.Option>
                          <Select.Option value=" Watermark"> Water mark</Select.Option>                           */}
              </Select>
            </Form.Item>
          </Col>
         
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item name="remarks" label="Remarks"
              rules={[
                {
                  required: false,
                  message: "It should not be blank",
                  pattern: /^[^-\s][a-zA-Z0-9_\s-]*$/,
                }
              ]}>
              <TextArea rows={1} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: 'right' }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
            {(props.isUpdate !== true) &&
              <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
                Reset
              </Button>
            }
          </Col>
        </Row>
      </Form>
    </Card>
  );
}

export default InterviewForm;
